// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"c0e55554","611":"60d23985","640":"c1d13228","705":"78b45b50","855":"83e0abfe","874":"cfd895f6","886":"e14d37a7","916":"e2354c04","953":"25c3e41b"}[chunkId] + ".chunk.js";
};